module.exports = __webpack_public_path__ + "media/images/img_kokubun-cd5e9389b2a93b01a407d22e489cf5de.jpg";